import { schema } from 'normalizr';

export const SUGGESTION_SCHEMA_KEY = 'suggestions';
export const SUGGESTERS_SCHEMA_KEY = 'suggesters';

export const userSchema = new schema.Entity(SUGGESTERS_SCHEMA_KEY);

export const suggestionsSchema = new schema.Entity(SUGGESTION_SCHEMA_KEY, {
  owner: userSchema,
});

export const suggestionListSchema = [suggestionsSchema];
